module.exports = __webpack_public_path__ + "img/circle_delete_outline.b439a208.svg";